import apiHandler from "../core/apiHandler";

const creditNoteSaleApi = apiHandler('credit-notes-sales');
export default creditNoteSaleApi;
